import { put, select } from 'redux-saga/effects';
import { loadFacebookSDKOnce } from 'utils/facebook';
import { setFacebookSdkLoadedAction } from 'common/actions/settings';
import { getShareViaFacebookSelector } from 'common/selectors/settings';
import { get } from 'lodash-es';

export function* loadFacebookSDKEffect() {
  try {
    const facebookFeature = yield select(getShareViaFacebookSelector);
    if (get(facebookFeature, 'enabled')) {
      yield loadFacebookSDKOnce();
      yield put(setFacebookSdkLoadedAction());
    }
  } catch (error) {}
}
